import withInjection from '@piconetworks/with-injection'
import CheckoutWithPlan from 'common/components/CheckoutWithPlan'

const mapStateToProps = (state, props) => {
    const guestLoader = state.loader.guest
    const userLoader = state.loader.user
    const scopedLoader = userLoader || guestLoader

    const planOptionId = state.plan.directPlanOptionId
    const hasPlanOption = ({ plan_option_id }) => plan_option_id === planOptionId

    const { tiers } = scopedLoader.pricing.monetization

    const tierContainingPlanOption = tiers.find(({ options }) => !!options.find(hasPlanOption))

    const tierId = tierContainingPlanOption.tier_id

    return {
        ...props,
        wizardName: props.router.query.id,
        planOptionId,
        tierId,
    }
}

const InjectedCheckout = withInjection(CheckoutWithPlan, {
    mapStateToProps,
})

export default InjectedCheckout
